<template>
  <div class="swh">
    <template v-for="(label, i) in steps">
      <div
        :key="'s' + i"
        class="swh__step"
        :class="{
          'swh__step--active': current === i + 1,
          'swh__step--done': current > i + 1
        }"
        >
        <span class="swh__num">
          <hero-icon v-if="current > i + 1" :icon="CheckIcon" :size="14" />
          <template v-else>{{ i + 1 }}</template>
        </span>
        <span class="swh__label">{{ label }}</span>
      </div>

      <span
        v-if="i < steps.length - 1"
        :key="'l' + i"
        class="swh__line"
        :class="{ 'swh__line--done': current > i + 1 }"
      ></span>
    </template>
  </div>
</template>

<script>
import HeroIcon from '@/components/shared/HeroIcon'
import CheckIcon from 'heroicons/24/outline/check.svg'

export default {
  components: { HeroIcon },

  props: {
    stepper: {
      required: true
    },
    property: {
      required: true,
      type: Object
    }
  },

  data: () => ({ CheckIcon }),

  computed: {
    current () {
      return parseInt(this.stepper)
    },

    steps () {
      return [
        this.$t('property.create.type.title'),
        'Características',
        this.$t('property.create.description.title'),
        this.$t('property.create.pictures.title'),
        this.$t('property.create.price.title')
      ]
    }
  }
}
</script>

<style scoped>
.swh {
  display: flex;
  align-items: flex-start;
  max-width: 640px;
  margin: 0 auto;
}
.swh__step {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 7px;
  flex: none;
}
.swh__num {
  width: 30px;
  height: 30px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 13px;
  font-weight: 700;
  background: #fff;
  border: 1.5px solid #e3ddd2;
  color: #a39a8c;
  transition: background 0.2s ease, border-color 0.2s ease, color 0.2s ease;
}
.swh__label {
  font-size: 11.5px;
  font-weight: 600;
  color: #a39a8c;
  white-space: nowrap;
}
.swh__line {
  flex: 1;
  height: 2px;
  background: #e3ddd2;
  margin: 14px 8px 0;
  transition: background 0.2s ease;
}
.swh__line--done { background: #1a1814; }

.swh__step--active .swh__num { background: #b52118; border-color: #b52118; color: #fff; }
.swh__step--active .swh__label { color: #1a1814; }
.swh__step--done .swh__num { background: #1a1814; border-color: #1a1814; color: #fff; }
.swh__step--done .swh__label { color: #56504a; }

@media (max-width: 640px) {
  .swh { max-width: 100%; }
  .swh__label { display: none; }
  .swh__line { margin-top: 14px; }
}
</style>
